(function () {
  const formWrapper = $('.form__wrapper'),
    accordionHeader = $('[data-accordion-toggle]'),
    accordionHeaderCustom = $('[data-accordion-toggle-custom]'),
    accordionBody = $('[data-accordion-body]'),
    accordionColor = $('.accordion-color'),
    selectedHeader = $('[data-selected-header]'),
    selectedSize = $('[data-selected-size]'),
    selectedLining = $('[data-selected-lining]'),
    // Roman Shades
    selectedRomanLining = $('[data-roman-selected-lining]'),
    selectedRomanDesign = $('[data-roman-selected-design]'),
    selectedRomanMount = $('[data-roman-selected-mount]'),
    selectedRomanSize = $('[data-roman-selected-size]'),
    selectedRomanLift = $('[data-roman-selected-lift]'),
    selectedRomanCord = $('[data-roman-selected-cord]'),
    nextStep = $('[data-next-step]');

  accordionHeader.click(function () {
    // accordionHeaderUpdates($(this));
  });

  accordionHeaderCustom.click(function () {
    // toggleHeader($(this));
  });

  nextStep.click(function () {
    openNextOption($(this));
  });

  const openNextOption = (_this) => {
    const curHeader = _this.parent().prev();
    const nextHeader = _this.parent().parent().next();
    const selectedOption = $('.custom-configurator-image-select-item-active');
    const width = $('#select-width-id option:selected').text();
    const height = $('#select-length-id option:selected').text();
    const subWidth = $('#select-sub-width-id option:selected').text();
    const subHeight = $('#select-sub-length-id option:selected').text();
    toggleOptions(_this, curHeader, nextHeader);
    displaySelectedOption(_this, curHeader, selectedOption, width, height);
    displaySelectedRomanOption(_this, curHeader, selectedOption, width, subWidth, height, subHeight);
  }

  const toggleOptions = (_this, curHeader, nextHeader) => {
    // close current option
    _this.closest(accordionBody).css('display', 'none');
    curHeader.removeClass('is-open');
    curHeader.addClass('selected-step');
    // open next option
    nextHeader.find(accordionHeader)[0].classList.add('is-open');
    nextHeader.find(accordionBody)[0].style.display = 'block';
  }

  const displaySelectedOption = (_this, curHeader, selectedOption, width, height) => {
    const curText = curHeader[0].innerText;

    if (curText.includes('Header')) {
      selectHeader(selectedOption)
      resetSizePosition()
    } else if (curText.includes('Size')) {
      selectSize(width, height)
      resetLinigPosition()
    } else if (curText.includes('Lining')) {
      selectLining(selectedOption)
      // resetOrderSummaryPosition()
    }
  }

  $('#cus_color_btn').click(function(){
    resetHeaderPosition();
  });

  const resetHeaderPosition = () => {
    $('html, body').animate({
      scrollTop: formWrapper.offset().top + 220
    }, 'slow');
  }
  const resetSizePosition = () => {
    $('html, body').animate({
      scrollTop: formWrapper.offset().top + 290
    }, 'slow');
  }
  const resetLinigPosition = () => {
    $('html, body').animate({
      scrollTop: formWrapper.offset().top + 350
    }, 'slow');
  }
  const resetOrderSummaryPosition = () => {
    $('html, body').animate({
      scrollTop: formWrapper.offset().top + 400
    }, 'slow');
  }

  const resetPosition = () => {
    setTimeout(() => {
      formWrapper.css({
        'overflow-y': 'unset',
        'overflow-x': 'unset'
      })
    }, 100);
  }

  const resetOverflow = () => {
    $(window).scroll(function () {
      formWrapper.css({
        'overflow-y': 'scroll',
        'overflow-x': 'hidden'
      });
    });
  }

  resetOverflow();

  // Roman Shades
  const displaySelectedRomanOption = (_this, curHeader, selectedOption, width, subWidth, height, subHeight) => {
    const curText = curHeader[0].innerText;

    if (curText.includes('Lining')) {
      selectRomanLining(selectedOption)
      resetRomanDesignPosition()
    } else if (curText.includes('Design')) {
      selectRomanDesign(selectedOption)
      resetRomanMountPosition()
    } else if (curText.includes('Mount')) {
      selectRomanMount(selectedOption)
      resetRomanMeasurementsPosition()
    } else if (curText.includes('Measurements')) {
      selectRomanSize(width, subWidth, height, subHeight)
      resetRomanLiftPosition()
    } else if (curText.includes('Lift')) {
      selectRomanLift(selectedOption)
      resetRomanCordPosition()
    } else if (curText.includes('Cord')) {
      selectRomanCord(selectedOption)
      resetRomanWindowDesPosition()
    } 

  }

  $('#color_btn').click(function(){
    resetRomanLiningPosition();
  });

  // const resetRomanPosition = () => {
  //   $('html, body').animate({
  //     scrollTop: formWrapper.offset().top - 1500
  //   }, 'slow');
  // }
  const resetRomanLiningPosition = () => {
    $('html, body').animate({
      scrollTop: formWrapper.offset().top + 170
    }, 'slow');
  }
  const resetRomanDesignPosition = () => {
    $('html, body').animate({
      scrollTop: formWrapper.offset().top + 250
    }, 'slow');
  }
  const resetRomanMountPosition = () => {
    $('html, body').animate({
      scrollTop: formWrapper.offset().top + 300
    }, 'slow');
  }
  const resetRomanMeasurementsPosition = () => {
    $('html, body').animate({
      scrollTop: formWrapper.offset().top + 370
    }, 'slow');
  }
  const resetRomanLiftPosition = () => {
    $('html, body').animate({
      scrollTop: formWrapper.offset().top + 430
    }, 'slow');
  }
  const resetRomanCordPosition = () => {
    $('html, body').animate({
      scrollTop: formWrapper.offset().top + 500
    }, 'slow');
  }
  const resetRomanWindowDesPosition = () => {
    $('html, body').animate({
      scrollTop: formWrapper.offset().top + 570
    }, 'slow');
  }  

  const toggleHeader = (_this) => {
    if (_this[0].className.includes('is-open')) {
      _this.removeClass('is-open');
      _this.next().css("display", "none");
    } else {
      accordionHeader.removeClass('is-open');
      accordionHeader.next().css("display", "none");
      _this.addClass('is-open');
      _this.next().css("display", "block");
    }
  }

  const accordionHeaderUpdates = (_this) => {
    const optionTitle = _this[0].innerText;
    const selectedOption = $('.custom-configurator-image-select-item-active');
    const width = $('#select-width-id option:selected').text();
    const height = $('#select-length-id option:selected').text();
    const subWidth = $('#select-sub-width-id option:selected').text();
    const subHeight = $('#select-sub-length-id option:selected').text();

    updateHeaderBG(optionTitle, _this);
    selectCustomAccordion(selectedOption, width, height, optionTitle, _this);
    selectRomanAccordion(selectedOption, width, subWidth, height, subHeight, optionTitle, _this);
  }

  const selectCustomAccordion = (selectedOption, width, height, optionTitle, _this) => {
    if (_this[0].className.includes('is-open')) {
      _this.addClass('selected-step');
      if (optionTitle.includes('Header')) {
        selectHeader(selectedOption);
      } else if (optionTitle.includes('Size')) {
        selectHeader(selectedOption);
        selectSize(width, height);
      } else if (optionTitle.includes('Lining')) {
        selectSize(width, height);
        selectLining(selectedOption);
      } else if (optionTitle.includes('Summary')) {
        selectLining(selectedOption);
      }
    }
  }
  
  // Roman Shades
  const selectRomanAccordion = (selectedOption, width, subWidth, height, subHeight, optionTitle, _this) => {
    if (_this[0].className.includes('is-open')) {
      _this.addClass('selected-step');

      if (optionTitle.includes('Lining')) {
        selectRomanLining(selectedOption);
      } else if (optionTitle.includes('Design')) {
        selectRomanLining(selectedOption);
        selectRomanDesign(selectedOption);
      } else if (optionTitle.includes('Mount')) {
        selectRomanDesign(selectedOption);
        selectRomanMount(selectedOption);
      } else if (optionTitle.includes('Measurements')) {
        selectRomanMount(selectedOption);
        selectRomanSize(width, subWidth, height, subHeight);
      } else if (optionTitle.includes('Lift')) {
        selectRomanSize(width, subWidth, height, subHeight);
        selectRomanLift(selectedOption);
      } else if (optionTitle.includes('Cord')) {
        selectRomanLift(selectedOption);
        selectRomanCord(selectedOption);
      } else if (optionTitle.includes('Summary')) {
        selectRomanCord(selectedOption);
      }

    }
  }

  const updateHeaderBG = (optionTitle, _this) => {
    if (!optionTitle.includes('Color')) accordionColor.addClass('selected-step');
     _this.parent().prev().find(accordionHeader).addClass('selected-step');
  }

  const selectHeader = (option) => selectedHeader.text(`: ${option[0].innerText}`);
  const selectSize = (width, height) => selectedSize.text(`: ${width}" W x ${height}" L`);
  const selectLining = (option) => selectedLining.text(`: ${option[1].innerText}`);
  // Roman Shades
  const selectRomanLining = (option) => selectedRomanLining.text(`: ${option[0].dataset.imageSelectItem}`);
  const selectRomanDesign = (option) => selectedRomanDesign.text(`: ${option[1].innerText}`);
  const selectRomanMount = (option) => selectedRomanMount.text(`: ${option[2].dataset.imageSelectItem}`);
  const selectRomanSize = (width, subWidth, height, subHeight) => selectedRomanSize.text(`: ${width}" ${subWidth} W x ${height}" ${subHeight} L`);
  const selectRomanLift = (option) => selectedRomanLift.text(`: ${option[4].dataset.imageSelectItem}`);
  const selectRomanCord = (option) => selectedRomanCord.text(`: ${option[5].dataset.imageSelectItem}`);

})();